<script setup lang="ts">
defineProps<{
    title: string;
    description: string;
    testId: string;
    disabled: boolean;
    icon: string;
}>();
</script>

<template>
    <q-card class="app-card bg-white full-height" :data-qs="testId" :class="{ 'app-card--disabled': disabled }">
        <q-icon
            class="q-mb-sm app-card-icon default-grey-icon-color"
            :name="`fa-light ui-extension-icon ${icon}`"
            size="32px"
        />
        <div class="q-mt-sm semi-bold qit-text-ellipsis-2-lines">
            {{ title }}
            <q-tooltip>{{ title }}</q-tooltip>
        </div>
        <div class="app-card-description qit-text-ellipsis-2-lines light-text-color">
            {{ description }}
            <q-tooltip>{{ description }}</q-tooltip>
        </div>
    </q-card>
</template>

<style lang="scss" scoped>
.app-card {
    padding: $spacing-m 12px $spacing-m 12px;
    border-radius: 8px;
    box-shadow: $card-shadow;
    display: flex;
    flex-direction: column;
    height: 100%;
    cursor: pointer;

    .app-card-description {
        font-size: 12px;
        line-height: 140%;
    }

    &--disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
}
</style>
